{
    "Accessibility menu": "Hozzáférhetőségi menü",
    "Close": "Bezárás",
    "Text and Reading": "Szöveg és olvasás",
    "Navigation and Interaction": "Navigáció és interakció",
    "Text Align": "Szöveg igazítása",
    "Align Left": "Balra igazítás",
    "Align Center": "Középre igazítás",
    "Align Right": "Jobbra igazítás",
    "Adjust Font Size": "Betűméret beállítása",
    "Highlight Title": "Cím kiemelése",
    "Highlight Links": "Linkek kiemelése",
    "Readable Font": "Olvasható betűtípus",
    "Color and Contrast": "Szín és kontraszt",
    "Dark Contrast": "Sötét kontraszt",
    "Light Contrast": "Világos kontraszt",
    "High Contrast": "Magas kontraszt",
    "High Saturation": "Magas telítettség",
    "Low Saturation": "Alacsony telítettség",
    "Monochrome": "Monokróm",
    "Tools": "Eszközök",
    "Reading Guide": "Olvasási útmutató",
    "Big Cursor": "Nagy kurzor",
    "Increase Font Size": "Betűméret növelése",
    "Decrease Font Size": "Betűméret csökkentése",
    "Letter Spacing": "Betűtávolság",
    "Line Height": "Sormagasság",
    "Font Weight": "Betűtípus vastagsága",
    "Dyslexia Font": "Diszlexia betűtípus",
    "Language": "Nyelv",
    "Accessibility widget": "Hozzáférhetőségi menü megnyitása",
    "Accessibility Profiles": "Hozzáférhetőségi profilok",
    "Cognitive Disability": "Kognitív fogyatékosság",
    "Seizure Safe": "Epilepsziás rohamokra biztonságos",
    "Accessibility statement": "Hozzáférhetőségi nyilatkozat",
    "ADHD": "ADHD",
    "Low Vision": "Gyengénlátás",
    "Pause Animations": "Animációk leállítása",
    "Animation paused": "Animáció szüneteltetve",
    "Reset all settings": "Beállítások visszaállítása",
    "Shortcut:": "Gyorsbillentyű:",
    "Epilepsy Safe Mode": "Epilepszia-biztos mód",
    "Mute sounds": "Hangok némítása",
    "Page read": "Oldal felolvasása",
    "Page read controls": "Felolvasás vezérlői",
    "Pause": "Szünet",
    "Resume": "Folytatás",
    "Stop": "Leállítás",
    "Settings": "Beállítások",
    "Speed": "Sebesség",
    "Voice": "Hang",
    "Close accessibility menu": "Hozzáférhetőségi menü bezárása",
    "Back to accessibility menu": "Vissza a hozzáférhetőségi menübe",
    "Search languages": "Nyelvek keresése",
    "Selected language": "Kiválasztott nyelv",
    "View accessibility statement (opens in new window)": "Hozzáférhetőségi nyilatkozat megtekintése (új ablakban nyílik meg)",
    "Visit CookieYes website (opens in new window)": "A CookieYes webhely felkeresése (új ablakban nyílik meg)",
    "Reset all accessibility settings to default": "Minden hozzáférhetőségi beállítás visszaállítása alapértelmezettre"
}
